export default __webpack_public_path__ + "static/media/avatar.2bdf4360.svg";